import { lazyWithRetry } from "@js/utils/lazy-with-retry";

export const CompleteProfileContentLazy = lazyWithRetry(async () => {
  const module = await import(
    /* webpackChunkName: "complete-profile-content" */ "../../components/complete-profile-content"
  );
  return { default: module.CompleteProfileContent };
});
